import { FC } from "react";

import wrench from "assets/images/wrench.svg"
const BaseLoader: FC = () => {
  return (
    <div className="text-center pre-loader">
      <object type="image/svg+xml" data={wrench}></object>
    </div>
  );
};

export default BaseLoader;
